.dialog {
    position: fixed;
    background-color: #d8d8d8;
    color: inherit;
    font: inherit;
    width: 570px;
    max-width: calc(100vw - 40px);
    top: 50%;
    left: 50%;
    right: auto;
    bottom: auto;
    margin: 0;
    padding: 20px;
    transform: translate(-50%, -50%);
    border: none;
    border-radius: 5px;
}

.dialog::backdrop {
    background-color: #000000;
    opacity: 0.8;
}

.box {
    background-color: #fff;
    padding: 10px;
}

.download {
    text-align: center;
}

.download button {
    margin: 5px 5px 0;
}
